/* Resolve the tenant directly from <database>.apit.am. */

const TENANT_PATTERN = /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/;

export function getTenantKey(hostname = null) {
	if (typeof window === "undefined" && !hostname) return "";
	const host = String(hostname || window.location.hostname || "")
		.trim()
		.toLowerCase()
		.replace(/\.$/, "");
	if (host === "webradio.am" || host.endsWith(".webradio.am")) {
		return "webradio";
	}
	const rootDomain = String(
		process.env.REACT_APP_TENANT_ROOT_DOMAIN || "apit.am"
	).toLowerCase();
	if (!host.endsWith(`.${rootDomain}`)) return "";

	const subdomain = host.slice(0, -(rootDomain.length + 1));
	if (!subdomain || subdomain.includes(".")) return "";
	if (subdomain === "admin") {
		const adminTenant = String(
			process.env.REACT_APP_PLATFORM_ADMIN_TENANT ||
			"adminapit"
		).trim().toLowerCase();
		return TENANT_PATTERN.test(adminTenant) ? adminTenant : "";
	}
	return TENANT_PATTERN.test(subdomain) ? subdomain : "";
}

export function getTenantOrigin(tenantKey = getTenantKey()) {
	if (!TENANT_PATTERN.test(String(tenantKey || ""))) return "";
	const rootDomain = process.env.REACT_APP_TENANT_ROOT_DOMAIN || "apit.am";
	const isLocal = rootDomain === "localhost" || rootDomain.endsWith(".localhost");
	const browserProtocol = typeof window !== "undefined" ? window.location.protocol : "";
	const browserPort = typeof window !== "undefined" ? window.location.port : "";
	const protocol =
		process.env.REACT_APP_TENANT_ORIGIN_PROTOCOL ||
		browserProtocol.replace(/:$/, "") ||
		(isLocal ? "http" : "https");
	const port =
		process.env.REACT_APP_TENANT_ORIGIN_PORT || (isLocal ? browserPort || "3030" : "");
	return `${protocol}://${tenantKey}.${rootDomain}${port ? `:${port}` : ""}`;
}
